<common-journey-management-base-jm-renderer
  [config]="jmConfig()"
  [isLoading]="isLoading()"
></common-journey-management-base-jm-renderer>
